export const Constants: {[key: string]: string} = {
    CONTEXT_PROVIDER_OFFSET_KEY_SUFFIX : '_offset',
    CONTEXT_PROVIDER_LAYOUT_KEY_SUFFIX: '_layouts',
};
